import {UseQueryResult, useQuery} from '@tanstack/react-query';
import IWDevice from '../client/IWDevice';
import IWPushNotifications from '../client/IWPushNotifications';

const localQueryOptions = {
    staleTime: Infinity,
    gcTime: Infinity,
    networkMode: 'always' as const,
    retry: false
};

export function useDeviceTokenQuery(): UseQueryResult<string | undefined, Error> {
    return useQuery<string | undefined>({
        queryKey: ['deviceToken'],
        queryFn: () => IWDevice.getDeviceToken(),
        ...localQueryOptions
    });
}

export function usePushEnvironmentQuery(): UseQueryResult<string, Error> {
    return useQuery<string>({
        queryKey: ['pushEnvironment'],
        queryFn: () => IWPushNotifications.getPushEnvironment(),
        ...localQueryOptions
    });
}
